export default __webpack_public_path__ + "assets/models/6698a3a368795fbee26a591a1d0c3205.glb";